// components/layout/StatusBar.jsx
// 底部状态栏: 引擎状态、版本、当前 T、点数

import { useSolPred } from '../../hooks/useSolPredStore';

export default function StatusBar() {
  const { selectedSystem, temperature, dataPoints, predicting } = useSolPred();

  return (
    <div className="statusbar">
      <span><i className="pulse-dot" />引擎就绪</span>
      <span className="status-divider" />
      <span>SQLite · 80,247 records</span>
      <span className="status-divider" />
      <span>PC-CVAE · v0.4.2</span>
      <span className="status-divider" />
      <span>T = {temperature}°C</span>
      <span className="status-divider" />
      <span>显示 {dataPoints.length} 点</span>
      {predicting && (
        <>
          <span className="status-divider" />
          <span style={{ color: 'var(--accent)' }}>⟳ 推理中</span>
        </>
      )}
      <span className="right">
        {selectedSystem.id} · {selectedSystem.components.join('–')} · SolPred © 2026
      </span>
    </div>
  );
}
